import React from 'react';
import { Button } from '@mui/material';
import { useGuardedNavigation } from '../../../permissions/useGuardedNavigation';

export default function ProductListPageActions() {
  const { navigateCreate } = useGuardedNavigation('products');

  return (
    <Button variant="contained" color="primary" onClick={navigateCreate}>
      + Create New Product
    </Button>
  );
}
